import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  year: number;
  month: number | null;
  quarter: number | null;
}

export const useGenerateIntrastatReport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ year, month, quarter }: HookProps) => {
      const result = await apiClient.declarationsReports.generateIntrastatReport.mutation({
        body: { year, month, quarter },
      });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getUserReports'] });
      toast.success('The report is being generated.');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating the report!');
    },
  });
};
